export enum ZipStatus {
  None,
  Running,
  Paused,
  ReadyForZipping,
  ReadyForEmailing,
  Complete,
  Downloaded,
  Expired,
  Deleted,
  Error,
}

export interface IZipSummaryResponse {
  Id?: number
  FileName?: string
  Status?: ZipStatus
  DownloadURL?: string
  ExpiryDate?: string
  CompletedDate?: string
}

export interface IZipSummaryResponseV1 {
  id?: number
  fileName?: string
  status?: ZipStatus
  downloadURL?: string
  expiryDate?: string
  completedDate?: string
}

export class ZipSummary {
  public id?: number
  public file?: string
  public status: ZipStatus = ZipStatus.None
  public downloadUrl?: string
  public expiredAt?: Date
  public completedAt?: Date

  constructor(summary: Partial<ZipSummary>) {
    this.id = summary.id
    this.file = summary.file
    this.status = summary.status ?? ZipStatus.None
    this.downloadUrl = summary.downloadUrl
    this.expiredAt = summary.expiredAt
    this.completedAt = summary.completedAt
  }

  public static fromResponse(summary?: IZipSummaryResponse) {
    const expiredAt = summary?.ExpiryDate ? new Date(summary?.ExpiryDate) : undefined
    const completedAt = summary?.CompletedDate ? new Date(summary?.CompletedDate) : undefined

    return new ZipSummary({
      id: summary?.Id,
      file: summary?.FileName,
      status: summary?.Status,
      downloadUrl: summary?.DownloadURL,
      expiredAt,
      completedAt,
    })
  }

  public static fromResponseV1(summary?: IZipSummaryResponseV1) {
    const expiredAt = summary?.expiryDate ? new Date(summary?.expiryDate) : undefined
    const completedAt = summary?.completedDate ? new Date(summary?.completedDate) : undefined

    return new ZipSummary({
      id: summary?.id,
      file: summary?.fileName,
      status: summary?.status,
      downloadUrl: summary?.downloadURL,
      expiredAt,
      completedAt,
    })
  }
}
